const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

// Le serveur de formulaires peut être en veille : son réveil prend jusqu'à ~45 s.
const WARMUP_TIMEOUT = 50_000;
const WARMUP_WAIT = 8_000;
const POST_TIMEOUT = 60_000;

export class ApiError extends Error {
  constructor(code, response) {
    super(code);
    this.code = code;
    this.response = response;
  }
}

const withTimeout = (ms) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), ms);
  return { signal: controller.signal, done: () => clearTimeout(timer) };
};

let warmupPromise;

export const warmBackend = () => {
  if (!BACKEND_URL || typeof window === "undefined") return Promise.resolve(false);
  if (!warmupPromise) {
    const { signal, done } = withTimeout(WARMUP_TIMEOUT);
    warmupPromise = fetch(`${API}/health`, { signal })
      .then((response) => response.ok)
      .catch(() => false)
      .finally(done);
  }
  return warmupPromise;
};

// Requête JSON vers l'API ; lève ApiError (avec .response si le serveur a répondu).
export const apiRequest = async (path, { method = "GET", body, token, timeout = POST_TIMEOUT } = {}) => {
  if (!BACKEND_URL) throw new ApiError("BACKEND_URL_MISSING");
  const { signal, done } = withTimeout(timeout);
  let response;
  try {
    response = await fetch(`${API}${path}`, {
      method,
      signal,
      headers: {
        ...(body ? { "Content-Type": "application/json" } : {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (err) {
    throw new ApiError(err.name === "AbortError" ? "TIMEOUT" : "NETWORK_ERROR");
  } finally {
    done();
  }
  if (!response.ok) throw new ApiError(`HTTP_${response.status}`, response);
  return response;
};

export const postToApi = async (path, payload) => {
  await Promise.race([warmBackend(), new Promise((resolve) => setTimeout(resolve, WARMUP_WAIT))]);
  const response = await apiRequest(path, { method: "POST", body: payload });
  return response.json().catch(() => ({}));
};

// Message d'erreur des formulaires : distingue un refus du serveur d'une indisponibilité.
export const submitErrorMessage = (err) =>
  err?.response
    ? "Le service n’a pas confirmé votre demande. Vérifiez les champs ou réessayez dans quelques instants."
    : "Le service d’envoi ne répond pas pour le moment. Votre demande n’a pas été envoyée : réessayez dans une minute.";
